import { render, staticRenderFns } from "./dayReport2.vue?vue&type=template&id=06b3b3b4&scoped=true&"
import script from "./dayReport2.vue?vue&type=script&lang=js&"
export * from "./dayReport2.vue?vue&type=script&lang=js&"
import style0 from "./dayReport2.vue?vue&type=style&index=0&id=06b3b3b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b3b3b4",
  null
  
)

export default component.exports